namespace $.$$ {

	export class $shm_ba_filter_list extends $.$shm_ba_filter_list {

		filter_all_off_key() {
			return '__all__'
		}

		names(): string[] {
			return ( this.table() as $shm_ba_data_table | null )?.rows.map( ([ name ] )=> String( name ) ) ?? []
		}

		filtered_names() {
			const query = this.search_query().trim().toLowerCase()
			if( !query ) return this.names()

			return this.names().filter( name => name.toLowerCase().includes( query ) )
		}

		visible_step() {
			return 10
		}

		visible_names() {
			return this.filtered_names().slice( 0, this.visible_count() )
		}

		can_more() {
			return this.visible_count() < this.filtered_names().length
		}

		can_collapse() {
			return this.visible_count() > this.visible_step()
		}

		all_selected( value: $shm_ba_data_filter_value ) {
			return value ? {} : { [ this.filter_all_off_key() ]: false } as $shm_ba_data_filter
		}

		selected_names( filter: $shm_ba_data_filter ) {
			return Object.entries( filter )
				.filter( ([ name, value ])=> name !== this.filter_all_off_key() && value === true )
				.map( ([ name ])=> name )
		}

		has_selected( filter: $shm_ba_data_filter ) {
			return this.selected_names( filter ).length > 0
		}

		all_off( filter: $shm_ba_data_filter ) {
			return filter[ this.filter_all_off_key() ] === false
		}

		row_views() {
			return [
				this.All(),
				... this.visible_names().map( name => this.Item( name ) ),
				... ( this.action_buttons().length ? [ this.Actions() ] : [] ),
			]
		}

		action_buttons() {
			return [
				... this.can_more() ? [ this.More() ] : [],
				... this.can_collapse() ? [ this.Collapse() ] : [],
			]
		}

		more( next?: Event ) {
			if( next === undefined ) return null
			this.visible_count( Math.min( this.visible_count() + this.visible_step(), this.filtered_names().length ) )
			return next
		}

		collapse( next?: Event ) {
			if( next === undefined ) return null
			this.visible_count( Math.min( this.visible_step(), this.filtered_names().length ) )
			return next
		}

		all_checked( next?: boolean ) {
			const filter = this.filter() as $shm_ba_data_filter
			if( next === undefined ) {
				if( filter[ this.filter_all_off_key() ] === false ) return false
				if( this.has_selected( filter ) ) return false
				return !Object.values( filter ).some( value => value === false || value === 'exclude' )
			}
			this.filter( this.all_selected( next ) )
			return next
		}

		item_title( name: string ) {
			return name
		}

		item_count( name: string ) {
			const row = ( this.table() as $shm_ba_data_table | null )?.rows.find( ([ item ] )=> String( item ) === name )
			return String( Number( row?.[1] ?? 0 ) )
		}

		status( name: string ) {
			const value = ( this.filter() as $shm_ba_data_filter )[ name ]
			return value === 'exclude' ? 'exclude' : value === false ? 'off' : 'on'
		}

		item_checked( name: string, next?: boolean ) {
			const filter = this.filter() as $shm_ba_data_filter
			if( next === undefined ) {
				if( filter[ this.filter_all_off_key() ] === false ) return filter[ name ] === true
				if( this.has_selected( filter ) ) return filter[ name ] === true
				return filter[ name ] === 'exclude' ? false : filter[ name ] ?? true
			}

			const next_filter = { ... filter }
			delete next_filter[ this.filter_all_off_key() ]

			if( next ) {
				if( this.all_off( filter ) || this.has_selected( filter ) ) {
					next_filter[ name ] = true
				} else {
					delete next_filter[ name ]
				}
			} else {
				if( this.has_selected( filter ) ) {
					delete next_filter[ name ]
					if( !this.has_selected( next_filter ) ) next_filter[ this.filter_all_off_key() ] = false
				} else {
					next_filter[ name ] = false
				}
			}

			this.filter( next_filter )
			return next
		}

		item_exclude( name: string, next?: Event ) {
			if( next === undefined ) return null

			const filter = this.filter() as $shm_ba_data_filter
			const next_filter = { ... filter }
			delete next_filter[ this.filter_all_off_key() ]
			if( next_filter[ name ] === 'exclude' ) {
				delete next_filter[ name ]
			} else {
				next_filter[ name ] = 'exclude'
			}
			this.filter( next_filter )
			return next
		}

		item_only( name: string, next?: Event ) {
			if( next === undefined ) return null

			this.filter({ [ name ]: true })
			return next
		}

	}

}
